/**
 * 将老组件的数据转换为新组件需要的数据，用于编辑
 */
export function convertDataFromOld2New(value) {
    let rs = {
        // 机器人转人工配置
        roleRobotToManual: value.roleRobotToManual || {},
        // 自助导航
        autoNavMenu: value.autoNavMenu || {},
        // 是否已失效
        isDisabled: value.isDisabled,
    };

    // 新组件中： 0单人，1分组，4机器人，6高级路由
    // 老组件中：2单人，3分组，4机器人，8高级路由
    switch (value.manualType) {
    case 2:
        rs = {
            ...rs,
            value: 0,
            uin: value.serviceKfext,
            data: value.serviceKfext,
            name: value.serviceKfextName,
        };
        break;
    case 3:
        rs = {
            ...rs,
            value: 1,
            uin: value.groupId,
            data: value.groupId,
            name: value.groupName,
        };
        break;
    case 4:
        rs = {
            ...rs,
            value: 4,
            uin: value.robotId,
            data: value.robotId,
            name: value.robotName,
        };
        if (value.robotNav) {
            rs.robotNav = {
                ...value.robotNav,
            };
        }
        break;
    case 8:
        rs = {
            ...rs,
            value: 6,
            uin: value.routeId,
            data: value.routeId,
            // 兜底：提交数据和回显数据不一致。提交为 routeGroupName， 回显为 routeName
            name: value.routeGroupName || value.routeName,
        };
        break;
    }

    console.log('convertDataFromOld2New', JSON.stringify(rs));

    return rs;
}

/**
 * 将新组件的数据转换为老数据，用于提交。
 */
export function convertDataFromNew2Old(value) {
    let manualType;
    let rs = {
        isHasDefault: false,
        // 机器人转人工配置
        roleRobotToManual: value.roleRobotToManual || {},
        // 自助导航
        autoNavMenu: value.autoNavMenu || {},
    };

    // 新组件中： 0单人，1分组，4机器人，6高级路由
    // 老组件中：2单人，3分组，4机器人，8高级路由
    switch (value.value) {
    case 0:
        manualType = 2;
        // 单人接待，需要补齐客服id和名字
        rs = {
            ...rs,
            serviceKfext: value.uin,
            serviceKfextName: value.name,
        };
        break;
    case 1:
        // 分组接待，需要补齐分组id和名字
        manualType = 3;
        rs = {
            ...rs,
            groupId: value.uin,
            groupName: value.name,
        };
        break;
    case 4:
        // 机器人接待，需要补齐机器人id和名字，以及机器人导航
        manualType = 4;
        rs = {
            ...rs,
            robotId: value.uin,
            robotName: value.name,
            robotIcon: '', // 新组件不返回这个数据，先留空
        };

        if (value.robotNav) {
            // 机器人导航数据转换
            // 注意，server已经对 current值进行了转换，直接使用robotNav值即可，不需要做其他处理。
            rs.robotNav = { ...value.robotNav };
        }

        break;
    case 6:
        // 高级路由接待，需要补齐分组id和名字和其他数据
        manualType = 8;
        rs = {
            ...rs,
            isHasDefault: true,
            routeId: value.uin,
            routeGroupID: value.uin,
            routeGroupName: value.name,
        };
        break;
    }

    const output = {
        manualType,
        value: rs,
    };

    console.log('convertDataFromNew2Old', output);
    return output;
}
